import React, { useState, useEffect } from "react";
import Select from "live/components/forms/ui/select";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { fetchApi } from "../../../api/fetchApi";
import { listPerspectivesApi } from "../../../api/perspectiveApi";

const UserGroupBox = ({
  company,
  addPerspective,
  removePerspective,
  itemUrl,
  userGroup,
}) => {
  const [options, setOptions] = useState([]);

  let showSelect = true;

  useEffect(() => {
    listPerspectivesApi(company.id)
    .then((response) => {
        let myOptions = response.data.map((perspective) => {
          //All perspectives
          return { id: perspective.id, name: perspective.name };
        });

        const removeItemFromMyOptions = (id) => {
          myOptions = myOptions.filter((option) => {
            return option.id !== id;
          });
        };

        userGroup.perspectives.map((perspective) => {
          removeItemFromMyOptions(perspective.id);
        });

        setOptions(myOptions);
    });
  
  }, [userGroup.id]);


  const getItem = (id) => {
    let index;
    const item = options.find((d, i) => {
      if (d["id"] === id) {
        index = i;
        return true;
      }
    });

    return item ? item : false;
  };

  const addItem = (id) => {
    const item = getItem(id);

    if (item) {
      addPerspective(item);
      removeItemFromOptions(id);
    }
  };

  const removeItem = (itemToRemove) => {
    removePerspective(itemToRemove);
    setOptions([{ id: itemToRemove.id, name: itemToRemove.name }, ...options]);
  };

  const removeItemFromOptions = (id) => {
    setOptions(
      options.filter((option) => {
        return option.id !== id;
      })
    );
  };

  return (
    <div className="select-list">
      <Select
        label="Add perspectives to this user group:"
        // placeholder={placeholder}
        options={options.map((perspective) => {
          return { value: perspective.id, label: perspective.name };
        })}
        // creatable={creatable}
        onChange={(value, option) => addItem(value)}
        className="Select-small"
        clearable={false}
        searchable={true}
      />
      <div className="list-area">
        <ul>
          {userGroup.perspectives.map((d) => (
            <li key={d["id"]}>
              {d["name"]}

              {showSelect ? (
                <span>
                  {itemUrl ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={<Tooltip id="exclude">{"View tooltip"}</Tooltip>}
                    >
                      <a
                        href={`${itemUrl}/${d["name"]}`}
                        target="_blank"
                        className="fa fa-external-link"
                      />
                    </OverlayTrigger>
                  ) : (
                    ""
                  )}

                  {d["id"] == company["perspectiveId"] ? (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="exclude">
                          {
                            "All user groups have access to this perspective by definition"
                          }
                        </Tooltip>
                      }
                    >
                      <i className="fa fa-info-circle" />
                    </OverlayTrigger>
                  ) : (
                    <OverlayTrigger
                      placement="top"
                      overlay={
                        <Tooltip id="exclude">{"Remove tooltip"}</Tooltip>
                      }
                    >
                      <button
                        className="remove-item warn"
                        onClick={() => removeItem(d)}
                      />
                    </OverlayTrigger>
                  )}
                </span>
              ) : null}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default UserGroupBox;
